/* eslint-disable no-param-reassign */
import React, { useRef, useEffect } from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import SinglePriceCard from "@qlik/qlik/src/components/Card/SinglePriceCard/SinglePriceCard";
import * as styles from "./PricingCards.module.css";
import { useAppContext } from "@qlik/qlik/src/context/AppContext";

/**
 * IconCard component
 * @param {Object} data - The data for the Pricing Cards
 * @returns {JSX.Element} - The Pricing Cards component
 */
const PricingCards = ({ data }) => {
    // Destructuring the data object to get the required properties
    const {
        cardItems,
        additionalConfiguration,
        backgroundColor,
        numberOfColumns,
        cardItemBackgroundColor,
        customId,
    } = data;
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "");
    const { sectionColorMapping } = getColorClassName(backgroundColor, cardItemBackgroundColor);
    const { setPricingFeaturedColumns } = useAppContext();

    useEffect(() => {
        setPricingFeaturedColumns(cardItems?.map((card) => Boolean(card?.eyebrowText)));
    }, [setPricingFeaturedColumns]);

    const sectionRef = useRef(null);

    return (
        <section
            ref={sectionRef}
            className={`mt-0 lg:mt-10 xl:mt-0 ${sectionSpacingClassName} ${sectionColorMapping.bgColor}`}
            id={customId}
        >
            <div className="container">
                <div className="row">
                    <div className={`${styles.cardGrid} grid gap-5 lg:grid-cols-${numberOfColumns}`}>
                        {cardItems?.map((pricingCardData) => (
                            <SinglePriceCard
                                key={pricingCardData.id}
                                data={pricingCardData}
                                cardItemBackgroundColor={cardItemBackgroundColor}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PricingCards;
